var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"page-estates-item-cover"},[(_vm.youtubeIframeCode)?_c('div',{staticClass:"page-estates-item-cover__video",domProps:{"innerHTML":_vm._s(_vm.youtubeIframeCode)}}):_c('div',{staticClass:"page-estates-item-cover__image",style:({ backgroundImage: _vm.backgroundImage })})])
}
var staticRenderFns = []

export { render, staticRenderFns }